import store from '@Store';
import { createRoot } from 'react-dom/client';
import { compose } from 'redux';
import { connect, Provider } from 'react-redux';

import withReducer from '@Hooks/withReducer';

import { globalSpinnerReducerKey } from './GlobalSpinnerConstants';
import globalSpinnerReducer from './GlobalSpinnerReducer';

import GlobalSpinner from './GlobalSpinner';
import { isShown, spinnerType } from './GlobalSpinnerSelectors';

const rootOfGlobalSpinner = document.createElement('div');

rootOfGlobalSpinner.setAttribute('class', 'root-of-global-spinner');
document.body.appendChild(rootOfGlobalSpinner);

const mapStrateToProps = (state) => ({
  isShown: isShown(state),
  spinnerType: spinnerType(state),
});

const Container = compose(withReducer(globalSpinnerReducerKey, globalSpinnerReducer, true), connect(mapStrateToProps))(GlobalSpinner);

createRoot(rootOfGlobalSpinner).render(
  <Provider store={store}>
    <Container />
  </Provider>
);

export default Container;
